import type { RoleConfig } from '../types.js';

export const saboteur: RoleConfig = {
  id: 'saboteur',
  faction: 'mafia',
  title: { ru: 'Саботажник', uk: 'Саботажник' },
  latin: 'SABOTEUR',
  number: '36',
  accent: '#9a4a4a',
  ability: {
    ru: 'Ночью затыкает рот игроку — он молчит этой и следующей ночью.',
    uk: 'Вночі затикає рота гравцеві — він мовчить цієї та наступної ночі.',
  },
  abilities: [
    { key: 'silence', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
